<template>
  <div class="checkboxes-input">
    <div class="form-group">
      <label class="col-sm-4 control-label">
        {{ field.label }} <span v-if="field.required" class="required">*</span>
      </label>
      <div class="col-sm-8">
        <div class="checkbox" v-for="object in field.objects">
          <label>
            <input type="checkbox" :value="object.uuid" v-model="field.value" :name="field.name + '[]'"/>
            <strong>{{ object[field.objectName] }}</strong>
          </label>
          <br/>
          {{ object.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxesInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: [],
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CheckboxesInput.vue?55d4d5fb